var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as moment from 'moment-timezone';
import addressService from '@/services/address.service';
import BaseModel from './BaseModel';
import DeliveryFlowModel from './DeliveryFlowModel';
import RestaurantHours from './RestaurantHours';
import { each } from 'lodash';
import { EPaymentServiceType } from '@/models/interfaces/Payment/EPaymentServiceType';
var LocationModel = /** @class */ (function (_super) {
    __extends(LocationModel, _super);
    function LocationModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.address = hydrated.address;
        _this.addressComponents = (hydrated.addressComponents) ? addressService.convertAddressComponents(hydrated.addressComponents) : null;
        _this.contactPhone = hydrated.contactPhone;
        _this.country = hydrated.country;
        _this.delivery = hydrated.delivery;
        _this.id = hydrated.id;
        _this.latitude = hydrated.latitude;
        _this.locale = hydrated.locale;
        _this.locality = hydrated.locality;
        _this.locationImageUrl = hydrated.locationImageUrl;
        _this.locationHours = hydrated.locationHours; // TODO deprecate location hours
        _this.restaurantHours = hydrated.restaurantHours;
        _this.longitude = hydrated.longitude;
        _this.name = hydrated.name;
        _this.onlineStoreClosedMessage = hydrated.onlineStoreClosedMessage;
        _this.onlineStoreOpen = hydrated.onlineStoreOpen;
        _this.newOnlineStoreWelcome = hydrated.newOnlineStoreWelcome;
        _this.paymentServiceType = hydrated.paymentServiceType;
        _this.pickupPromiseTime = hydrated.pickupPromiseTime;
        _this.postalCode = hydrated.postalCode;
        _this.pushHost = hydrated.pushHost;
        _this.pushPort = hydrated.pushPort;
        _this.pushSecure = hydrated.pushSecure;
        _this.state = hydrated.state;
        _this.streetName = hydrated.streetName;
        _this.streetNumber = hydrated.streetNumber;
        _this.timeZone = hydrated.timeZone;
        _this.__mc = 'LocationModel';
        return _this;
    }
    LocationModel.prototype.hydrate = function (data) {
        var hydrated = {
            delivery: {}
        };
        hydrated.address = data.address || null;
        hydrated.addressComponents = data.address_obj ? data.address_obj.address_components : null;
        hydrated.id = data.base || null;
        hydrated.name = data.name || null;
        hydrated.country = data.address_obj ? data.address_obj.country : null;
        hydrated.contactPhone = data.contact_phone || null;
        hydrated.newOnlineStoreWelcome = +(data.online_store_welcome) || false;
        // TODO delivery flow model should be its own model
        if (data.delivery_flow_model) {
            var deliveryFlow = data.delivery_flow_model;
            hydrated.delivery = new DeliveryFlowModel(__assign({}, deliveryFlow, { 
                // props located in DFM or on root location
                base_delivery_fee: deliveryFlow.base_delivery_fee || data.delivery_charge, promise_time: deliveryFlow.delivery_promise_time || data.delivery_promise_time, delivery_radius: data.delivery_radius, delivery_radius_unit: data.delivery_radius_unit }));
        }
        hydrated.latitude = typeof data.latitude !== undefined ? parseFloat(data.latitude) : null;
        hydrated.longitude = typeof data.longitude !== undefined ? parseFloat(data.longitude) : null;
        // address
        hydrated.locality = data.address_obj ? data.address_obj.locality : null;
        hydrated.paymentServiceType = _super.prototype.convertInt.call(this, data.payment_service_type) || EPaymentServiceType.TYPE_E;
        hydrated.pickupPromiseTime = data.payment_loyalty_flow_model ? parseInt(data.payment_loyalty_flow_model.pickup_promise_time) : 20;
        hydrated.postalCode = data.address_obj ? data.address_obj.postal_code : null;
        hydrated.state = data.address_obj ? data.address_obj.state : null;
        hydrated.streetName = data.address_obj ? data.address_obj.street_name : null;
        hydrated.streetNumber = data.address_obj ? data.address_obj.street_number : null;
        // time information
        hydrated.locale = data.locale || null;
        hydrated.locationHours = [];
        hydrated.timeZone = data.timeZoneId || null;
        hydrated.onlineStoreOpen = data.hasOwnProperty('online_store_open') ? data.online_store_open : false;
        hydrated.onlineStoreClosedMessage = data.online_store_closed_message ? data.online_store_closed_message : 'Please call store';
        if (data.location_hours) {
            // TODO deprecate location hours for RestaurantHours
            hydrated.locationHours = LocationModel.convertLocationHoursObj(data.location_hours, hydrated.timeZone);
            hydrated.restaurantHours = new RestaurantHours(data.location_hours);
        }
        hydrated.locationImageUrl = data.loc_app_store_location_img;
        hydrated.pushHost = data.push_host || null;
        hydrated.pushPort = data.push_port || null;
        hydrated.pushSecure = typeof data.push_secure !== undefined ? data.push_secure : false;
        return hydrated;
    };
    LocationModel.prototype.hydrateFromStore = function (data) {
        var location = {};
        location = data;
        return location;
    };
    LocationModel.prototype.getGoogleMapsAPIKey = function () {
        var deliveryFlowModel = this.delivery;
        if (deliveryFlowModel) {
            var apiKey = deliveryFlowModel.googleMapsApiKey;
            if (apiKey) {
                return apiKey;
            }
        }
        return false;
    };
    LocationModel.convertLocationHoursObj = function (locationHours, timeZone) {
        var convertedHours = [];
        if (locationHours) {
            locationHours.forEach(function (hourObj) {
                var startTime = (!hourObj.start_time) ? null : moment(hourObj.start_time).tz(timeZone);
                var endTime = (!hourObj.end_time) ? null : moment(hourObj.end_time).tz(timeZone);
                convertedHours.push({
                    startTime: startTime,
                    endTime: endTime,
                    startTimeISO: hourObj.start_time,
                    endTimeISO: hourObj.end_time,
                    isClosed: (hourObj.is_closed) ? hourObj.is_closed : false,
                    msg: hourObj.msg || ''
                });
            });
        }
        else {
            // location hours didn't exist, set default 10:00AM - 11:00PM
            var openHours = { hours: 10, minutes: 0, seconds: 0, milliseconds: 0 };
            var closeHours = { hours: 10, minutes: 0, seconds: 0, milliseconds: 0 };
            var dateToAdd = moment().set(openHours);
            for (var i = 0; i < 30; i++) {
                dateToAdd.add({ days: i });
                convertedHours.push({
                    startTime: moment(dateToAdd).set(openHours),
                    endTime: moment(dateToAdd).set(closeHours),
                    isClosed: false,
                    msg: ''
                });
            }
        }
        return convertedHours;
    };
    // TODO move location time related functions into a StoreHours class
    LocationModel.prototype.getAvailableDays = function () {
        var locationHours = this.locationHours;
        var currentTime = moment.now();
        var days = [];
        if (!locationHours) {
            return [];
        }
        if (locationHours.length === 0) {
            return [];
        }
        each(locationHours, function (hours, index) {
            if (!hours) {
                return;
            }
            var day = {};
            day['value'] = index;
            var startTime = moment(hours.startTime);
            var endTime = moment(hours.endTime);
            if (index === 0) {
                day['name'] = 'Today';
                if (typeof startTime.isBefore !== 'function') {
                    return;
                }
                if (startTime.isBefore(currentTime) &&
                    endTime.isAfter(currentTime)) {
                    days.push(day);
                    return;
                }
            }
            else if (index === 1) {
                day['name'] = 'Tomorrow';
            }
            else if (index > 1 && index < 7) {
                day['name'] = startTime.format('dddd');
            }
            else {
                day['name'] = startTime.format('MMMM Do');
            }
            days.push(day);
        });
        return days;
    };
    LocationModel.prototype.getDaysHours = function (dayToCheck) {
        var year = dayToCheck.year();
        var month = dayToCheck.month();
        var day = dayToCheck.dayOfYear();
        if (this.locationHours) {
            for (var _i = 0, _a = this.locationHours; _i < _a.length; _i++) {
                var locationDay = _a[_i];
                var startTime = locationDay.startTime;
                if (!moment.isMoment(startTime)) {
                    startTime = moment(startTime);
                }
                if (year === startTime.year() && month === startTime.month() && day === startTime.dayOfYear()) {
                    return locationDay;
                }
            }
        }
    };
    LocationModel.prototype.getTodayHours = function () {
        var currentTime = moment();
        var todaysHours = this.getDaysHours(currentTime);
        return todaysHours;
    };
    LocationModel.prototype.getWeekHours = function () {
        var formattedDays = this.restaurantHours.formattedDays;
        var hours = formattedDays.slice(0, 7);
        return hours;
    };
    LocationModel.prototype.getLocality = function () {
        var addressComponents = this.addressComponents;
        var locality = addressComponents && addressComponents.locality;
        if (!locality) {
            return '';
        }
        var name = locality.longName || locality.shortName;
        return name || '';
    };
    LocationModel.prototype.getAptNum = function () {
        // TODO this information should come from an address component model
        var addressComponents = this.addressComponents;
        var apartmentNumber = addressComponents && addressComponents.aptNum;
        var shortName = apartmentNumber && addressComponents.shortName;
        return shortName || '';
    };
    LocationModel.prototype.getAbbreviatedAddress = function () {
        var address = this.address;
        var abbreviated = address.split(this.state)[0];
        var abbreviatedArray = abbreviated.split(',');
        abbreviatedArray.pop();
        return abbreviatedArray.join(',');
    };
    return LocationModel;
}(BaseModel));
export default LocationModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/LocationModel.ts
// module id = null
// module chunks = 